'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import notFoundNewConsumerApp from 'commons/notFoundNewConsumerApp';
import ProductListingPage from 'components/consumer/ProductListingPage';
import CategoryStoresContext from 'data-hooks/context/CategoryStoresContext';
import useProductStoresForCategory from 'data-hooks/useProductStoresForCategory';
import useCategoryPageData from './hooks/useCategoryPageData';
const CategoryPageWithData = t0 => {
  const $ = _c(17);
  const {
    sidebarHeader,
    slug,
    serverData
  } = t0;
  const location = useLocation();
  let t1;
  if ($[0] !== serverData || $[1] !== slug) {
    t1 = {
      slug,
      serverData
    };
    $[0] = serverData;
    $[1] = slug;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const pageData = useCategoryPageData(t1);
  let t2;
  if ($[3] !== location.search) {
    const searchParams = new URLSearchParams(location.search);
    t2 = searchParams.get("showMultipleStores");
    $[3] = location.search;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const enableMultipleStores = t2 === "true";
  const t3 = !enableMultipleStores;
  let t4;
  if ($[5] !== slug || $[6] !== t3) {
    t4 = {
      categorySlug: slug,
      skip: t3
    };
    $[5] = slug;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const storesContext = useProductStoresForCategory(t4);
  let t5;
  let t6;
  if ($[8] !== pageData) {
    t5 = () => {
      if (pageData && !pageData?.loading && !pageData?.pageId) {
        notFoundNewConsumerApp();
      }
    };
    t6 = [pageData];
    $[8] = pageData;
    $[9] = t5;
    $[10] = t6;
  } else {
    t5 = $[9];
    t6 = $[10];
  }
  useEffect(t5, t6);
  let t7;
  if ($[11] !== pageData || $[12] !== sidebarHeader) {
    t7 = <ProductListingPage pageData={pageData} sidebarHeader={sidebarHeader} />;
    $[11] = pageData;
    $[12] = sidebarHeader;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== storesContext || $[15] !== t7) {
    t8 = <CategoryStoresContext.Provider value={storesContext}>{t7}</CategoryStoresContext.Provider>;
    $[14] = storesContext;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};
CategoryPageWithData.propTypes = {
  sidebarHeader: PropTypes.node,
  slug: PropTypes.string,
  serverData: PropTypes.object
};
const CategoryPageLegacy = t0 => {
  const $ = _c(4);
  const {
    sidebarHeader,
    serverCategoryData,
    slug
  } = t0;
  const t1 = serverCategoryData ?? null;
  let t2;
  if ($[0] !== sidebarHeader || $[1] !== slug || $[2] !== t1) {
    t2 = <CategoryPageWithData sidebarHeader={sidebarHeader} slug={slug} serverData={t1} />;
    $[0] = sidebarHeader;
    $[1] = slug;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
CategoryPageLegacy.propTypes = {
  sidebarHeader: PropTypes.node,
  serverCategoryData: PropTypes.object,
  slug: PropTypes.string
};
export default CategoryPageLegacy;